<div class="modal-header">
  <h4 class="modal-title" id="exampleModalLabel1">{{option}} Rol</h4>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    mat-dialog-close
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>


  <!-- Nombre del Rol -->
  <mat-form-field style="width: 100%">
    <mat-label>Nombre</mat-label>
    <input type="text" [(ngModel)]="form['name']" matInput placeholder="Ingrese su nombre"/>
    <!-- <mat-error *ngIf="form.get('nombre').hasError('required')">El nombre es <strong>requerido</strong></mat-error>
    <mat-error *ngIf="form.get('nombre').hasError('pattern')">Solo se admiten <strong>letras</strong></mat-error>
    <mat-error *ngIf="form.get('nombre').hasError('maxlength')">El maximo de letras es <strong>15 </strong></mat-error> -->
  </mat-form-field>
  <br />
  <!-- Permisos -->
  <div>
    <mat-tab-group>
      <mat-tab label="Gestión de Operaciones">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Gestión de Operaciones'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Casos">
        <div class="permisos-box row">
          <ng-container *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Casos'" >
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Casos Malla">
        <div class="permisos-box row">
          <ng-container *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Casos Malla'" >
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Sakes">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Sakes'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Tipos">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Tipos'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Vinculación Casos/Sakes">
        <div class="permisos-box row">
          <ng-container *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Vinculación Casos/Sakes'" >
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Cuenta Maestra">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Cuenta Maestra'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Usuarios">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Usuarios'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Roles">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Roles'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Conexiones">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Conexiones'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Reportes">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Reportes'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="WIDGETS">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'WIDGETS'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Administrador de Tareas">
        <div class="permisos-box row">
          <ng-container  *ngFor="let permiso of permisos" >
            <div class="col-sm-12 col-md-6" *ngIf="permiso.seccion === 'Administrador de Tareas'">
              <mat-checkbox [(ngModel)]="form[permiso.nombre]" > {{ permiso.nombre }} </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </mat-tab>
    </mat-tab-group>
    <button (click)="guardarPermisos()" class="btn btn-info waves-effect float-right mt-3" >
      <i class="far fa-save"></i> Guardar
    </button>
  </div>
